import { render } from "./SingleStat.vue?vue&type=template&id=a6c94dfe&scoped=true"
import script from "./SingleStat.vue?vue&type=script&lang=js"
export * from "./SingleStat.vue?vue&type=script&lang=js"

import "./SingleStat.vue?vue&type=style&index=0&id=a6c94dfe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c94dfe"]])

export default __exports__